import React from 'react';
import { BlockZone } from './BlockZone';

export const TemplateBlocksZone = ({
  blocks,
  heroData,
  pageId,
  doc,
  options,
}: {
  heroData?: any;
  blocks: any[];
  pageId?: string;
  doc?: any;
  options?: any;
}) => {
  const _blocks = blocks?.filter((block) => block);
  return _blocks?.map(({ id, anchor, ...block }: any, key: number) => {
    return (
      <BlockZone
        anchor={anchor}
        block={block}
        blocks={blocks}
        doc={doc}
        heroData={heroData}
        key={key}
        id={id}
        pageId={pageId}
        options={options}
      />
    );
  });
};
